module.exports = __webpack_public_path__ + "static/media/mygov-id.8bc42454.svg";